import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrderTypesEnum } from "../../../utils/enums";
import { getFranchiseIsOpenData } from "../http/getFranchiseConfig";

export interface FranchiseStatusInitialState {
  isFranchiseOpen: boolean;
  franchiseReason?: string;
  isOpenDelivery: boolean;
  deliveryReason?: string;
  currentIsOpen: boolean;
  currentReason?: string;
  selfServiceWithoutSignIn?: boolean;
  selfService: boolean;
}

const initialState: FranchiseStatusInitialState = {
  isFranchiseOpen: true,
  isOpenDelivery: true,
  deliveryReason: "",
  franchiseReason: "",
  currentIsOpen: true,
  currentReason: "",
  selfService: false,
  selfServiceWithoutSignIn: false,
};

const franchiseStatus = createSlice({
  name: "franchiseStatusSlice",
  initialState,
  reducers: {
    updateCurrentOperatingHours: (
      state,
      action: PayloadAction<{
        orderType: string | undefined;
      }>
    ) => {
      if (action.payload.orderType === OrderTypesEnum.DELIVERYV2) {
        state.currentIsOpen = state.isFranchiseOpen && state.isOpenDelivery;
        state.currentReason = state.deliveryReason || state.franchiseReason;
      } else {
        state.currentIsOpen = state.isFranchiseOpen;
        state.currentReason = state.franchiseReason;
      }
    },

    updateSelfService: (
      state,
      action: PayloadAction<{
        selfService: boolean;
        selfServiceWithoutSignIn?: boolean;
      }>
    ) => {
      state.selfService = action.payload.selfService;
      state.selfServiceWithoutSignIn = action.payload.selfServiceWithoutSignIn;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFranchiseIsOpenData.fulfilled, (state, { payload }) => {
      state.isFranchiseOpen = payload.data.isFranchiseOpen;
      state.franchiseReason = payload.data.reason;
      state.isOpenDelivery = payload.data.isFranchiseDeliveryOpen;
      state.deliveryReason = payload.data.deliveryReason;

      if (payload.orderType === OrderTypesEnum.DELIVERYV2) {
        state.currentIsOpen =
          payload.data.isFranchiseOpen && payload.data.isFranchiseDeliveryOpen;
        state.currentReason =
          payload.data.reason || payload.data.deliveryReason;
      } else {
        state.currentIsOpen = payload.data.isFranchiseOpen;
        state.currentReason = payload.data.reason;
      }
    });
  },
});

export const { updateCurrentOperatingHours, updateSelfService } =
  franchiseStatus.actions;

export default franchiseStatus.reducer;
